import React, {useState} from 'react';
import {Flex, Button, Input, PriorityIcon} from '@priority-software/priority-style-react';
import {getLang} from '../../../../Localization';
import {LangSelect} from './LangSelect';
import styles from '../styles/templateInput.module.scss';

const NewTemplateInput = props => {
    const [title, setTitle] = useState('');
    const [templateLang, setTemplateLang] = useState(props.isEnglishHTML ? '3' : getLang());

    const handleNameChange = e => {
        setTitle(e.target.value);
    };

    const createNewTemplate = () => {
        const {onNew} = props;
        onNew(title, templateLang);
        setTitle('');
    };

    const onLangSelect = lang => {
        setTemplateLang(lang.value);
    };

    const {btntext, placeholder, isEnglishHTML} = props;

    return (
        <div>
            <Flex>
                <Input
                    value={title}
                    componentClasses={styles.footerInput}
                    size="large"
                    placeholder={placeholder}
                    onChange={handleNameChange}
                />
                {!isEnglishHTML && (
                    <LangSelect
                        templateLang={templateLang}
                        options={props.langs}
                        onLangSelect={onLangSelect}
                    />
                )}
            </Flex>
            <Button
                componentClasses={styles.createButton}
                size="large"
                darkContainer
                onClick={createNewTemplate}
                prefixIcon={PriorityIcon.add}
            >
                {btntext}
            </Button>
        </div>
    );
};

export default NewTemplateInput;
